export const foreignKeyMapping = {
  contacts: "contact_id",
};
